import "./index.css";
import Cookies from "js-cookie";
import Linkify from "react-linkify";
import ReplyInput from "../ReplyInput";
import { FaMicrophone, FaVideo } from "react-icons/fa6";
import Zoom from "react-medium-image-zoom";
import VoiceMessage from "../VoiceMessage";
import { CiVideoOn } from "react-icons/ci";
import { Box, Modal } from "@mui/material";
import { FaRegSmile } from "react-icons/fa";
import { useContext, useEffect, useState } from "react";
import { FaPlayCircle } from "react-icons/fa";
import { FaRegFilePdf } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { RxCrossCircled } from "react-icons/rx";
import { IoDocumentText } from "react-icons/io5";
import "react-medium-image-zoom/dist/styles.css";
import { HiOutlinePhotograph } from "react-icons/hi";
import { IoDocumentTextOutline } from "react-icons/io5";
import LinkPreviewSkeleton from "../LinkPreviewSkeleton";
import { MdOutlineDownloadForOffline } from "react-icons/md";
import CONSTANTS from "src/components/services/api";
import { MyContext } from "src/components/Context/MyContext";

const RecivedMessageTemplate = ({
  msgCss,
  openReply,
  data,
  isModalOpen,
  handleOpen,
  handleOpenModal,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  handleMessageReply,
  setActiveAudio,
  activeAudio,
  handleCopy,
  isAtBottom,
  scrollToMessage,
}) => {
  const roleId = Cookies.get("roleId");
  const authorName = Cookies.get("name");
  const { userId } = useContext(MyContext);

  const [videoModal, setVideoModal] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [isZoomed, setIsZoomed] = useState(false);
  const [previewLoader, setPreviewLoader] = useState(false);

  const replyData = data?.replyMessage?.length ? data.replyMessage[0] : null;
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "1px solid #F0F0F0",
    borderRadius: "8px",
    outline: "none",
    maxWidth: "100vw",
    maxHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100vw",
  };
  const [preview, setPreview] = useState({});

  useEffect(() => {
    const fetchPreview = async () => {
      setPreviewLoader(true);

      try {
        if (data.content?.indexOf("http") === 0) {
          const res = await fetch(`${CONSTANTS.CHAT_BASE}/api/generateLinkPreview`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              url: data.content,
            }),
          });

          if (!res.ok) {
            // This throws an error that will be caught in the catch block
            throw new Error(`Server error: ${res.status} ${res.statusText}`);
          }

          const result = await res.json();
          setPreview((prev) => ({
            ...prev,
            [`key_${data._id}`]: data?._id,
            title: result.data?.title,
            description: result.data?.description,
            image: result.data?.image?.url,
            url: result?.data?.url,
          }));
        }
      } catch (error) {
        console.error("Error fetching link preview:", error);
        // Error message if error in fetch the link preview
        // toast.error(error?.message || "An error occurred while fetching the link preview.", {
        //   position: "top-center",
        //   autoClose: 1000,
        //   transition: Bounce,
        // });
      } finally {
        setPreviewLoader(false);
      }
    };
    data.type === "text" && data.content?.indexOf("http") === 0 && fetchPreview();
  }, []);

  function getFileTypeFromURL(url) {
    const urlParts = url.split("/");
    const fileName = urlParts[urlParts.length - 1];
    const fileExtension = fileName.split(".").pop().toLowerCase();

    switch (fileExtension) {
      case "pdf":
        return "pdf";
      case "doc":
      case "docx":
        return "Word Document";
      default:
        return "Unknown File Type";
    }
  }

  const downloadFile = async (dataFile) => {
    const url = dataFile;
    window.open(url, "_blank");

    // try {
    //   const response = await fetch(url);
    //   const blob = await response.blob();
    //   const blobUrl = window.URL.createObjectURL(blob);

    //   const link = document.createElement("a");
    //   link.href = blobUrl;
    //   link.setAttribute("download", "sample.pdf");
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);

    //   // Clean up blob URL
    //   window.URL.revokeObjectURL(blobUrl);
    // } catch (error) {
    //   console.error("Error downloading the file:", error);
    // }
  };

  return (
    <>
      <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <div
          className={`relative w-full max-w-[40vw] bg-white text-sm font-normal flex flex-col justify-center rounded-[10px] rounded-tl-none shadow-md shadow-[#ED62141A] ${msgCss}`}
        >
        
          {roleId === "1" ? <h3 className="font-medium px-2 pt-2">{data?.authorName}</h3> : data.authorName == "ImWow Super Admin" && <h3 className="font-medium px-2 pt-2">ImWow Super Admin</h3>}
          {data?.type === "video" ? (
            <div className="w-[180px] h-[180px] opacity-60 z-0  bg-white  flex  float-start justify-center items-center  rounded-[12px] shadow-sm shadow-[#ED62141A] relative">
              <img src={data?.thumbnail} className="w-full h-full object-cover  rounded-[12px]" />
              <FaPlayCircle size={35} className="absolute opacity-100 z-50 cursor-pointer" color="white" onClick={() => setVideoModal(true)} />
              <FaVideo className="absolute bottom-0 left-1" color="white" />
              <p className="font-extralight text-[11px] text-white -mt-1.5 flex justify-end items-center gap-x-1 absolute bottom-0 right-2 pointer-events-none">
                {data?.timeFormated}
              </p>
            </div>
          ) : null}

          {data?.type === "file" ? (
            <div
              className="w-[270px] h-[180px]  bg-white  flex  float-start justify-center items-center  rounded-[12px] shadow-sm shadow-[#ED62141A] relative"
              onClick={() => downloadFile(data.content)}
            >
              <img src={data?.thumbnail} className="w-full h-full object-cover  rounded-[12px]" />
              <div className="bg-green-200 h-[75px] absolute bottom-0 w-full">
                <div className="flex py-3 bg-green-100 m-1 border-r-2 justify-between">
                  <div className="flex">
                    {getFileTypeFromURL(data.content) == "pdf" ? (
                      <FaRegFilePdf size={20} />
                    ) : getFileTypeFromURL(data.content) == "Word Document" ? (
                      <IoDocumentText size={20} />
                    ) : null}
                    <p className="text-sm pl-2 w-[195px] overflow-hidden">{data.content.split("/")[data.content.split("/").length - 1]}</p>
                  </div>
                  <MdOutlineDownloadForOffline color="#495057" size={25} />
                </div>
                <p className="font-extralight text-[11px] text-white -mt-1.5 flex justify-end items-center gap-x-1 absolute bottom-0 right-2">{data?.timeFormated}</p>
              </div>
            </div>
          ) : null}

          {/* if data type is image */}
          {data?.type === "image" ? (
            <div className="w-[180px] h-[180px] bg-white flex float-end justify-center items-center rounded-[20px] shadow-sm shadow-[#7314ED1A] relative">
              <img
                src={data?.content}
                className="w-full h-full object-cover rounded-[12px] cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setImageModal(true);
                }}
              />
              <p className="font-extralight text-[11px] text-white -mt-1.5 flex justify-end items-center gap-x-1 absolute bottom-0 right-2 pointer-events-none">
                {data?.timeFormated}
              </p>
            </div>
          ) : null}

          {/* show for the reply data  */}
          {data.replyMessage.length > 0 ? (
            <div onClick={() => scrollToMessage(data.replyMessage[0]._id)} className="cursor-pointer">
              {data.replyMessage[0].type == "text" ? (
                <Linkify
                  componentDecorator={(decoratedHref, decoratedText, key) => (
                    <a target="_blank" rel="noopener noreferrer" href={decoratedHref} key={key} className="link">
                      {decoratedText}
                    </a>
                  )}
                >
                  <div className="rounded-[10px] flex w-[315px] bg-[#EAFCE7] h-[58px] overflow-hidden my-4 border-opacity-25  mt-3 mb-3">
                    <div className="bg-[#06CF9C] w-[5px] pl-1"></div>
                    <div className="ml-2 flex flex-col justify-center">
                      <h1 className="text-sm font-medium text-[#06CF9C]">
                        {String(data.replyMessage[0].author) == userId
                          ? data.authorName !== "ImWow Super Admin"
                            ? data.replyMessage[0].authorName
                            : "You"
                          : data.replyMessage[0].authorName}
                      </h1>
                      <p className="text-sm font-normal text-[#92929D] mt-2 text-ellipsis text-nowrap ">{data.replyMessage[0].content}</p>
                    </div>
                  </div>
                </Linkify>
              ) : data.replyMessage[0].type == "image" ? (
                <div className="rounded-[10px] flex w-full bg-[#EAFCE7] h-[58px] overflow-hidden my-4 border-opacity-25  mt-3 mb-3">
                  <div className="bg-[#06CF9C] w-[5px]"></div>
                  <div className="ml-2 flex flex-col justify-center w-full">
                    <h1 className="text-sm font-medium text-[#06CF9C]">
                      {String(data.replyMessage[0].author) == userId
                        ? data.authorName !== "ImWow Super Admin"
                          ? data.replyMessage[0].authorName
                          : "You"
                        : data.replyMessage[0].authorName}
                    </h1>
                    <div className="flex justify-between w-full items-center">
                      <div className="flex items-center gap-x-1">
                        <HiOutlinePhotograph />
                        <p>Photo</p>
                      </div>
                      <img src={data.replyMessage[0].content} className="w-[40px] h-[40px] rounded-[10px] mr-2" />
                    </div>
                  </div>
                </div>
              ) : data.replyMessage[0].type == "video" ? (
                <div className="rounded-[10px] flex w-full bg-[#EAFCE7] h-[58px] overflow-hidden my-4 border-opacity-25  mt-3 mb-3">
                  <div className="bg-[#06CF9C] w-[5px]"></div>
                  <div className="ml-2 flex flex-col justify-center w-full">
                    <h1 className="text-sm font-medium text-[#06CF9C]">
                      {String(data.replyMessage[0].author) == userId
                        ? data.authorName !== "ImWow Super Admin"
                          ? data.replyMessage[0].authorName
                          : "You"
                        : data.replyMessage[0].authorName}
                    </h1>
                    <div className="flex justify-between w-full items-center">
                      <div className="flex items-center gap-x-1">
                        <CiVideoOn />
                        <p>Video</p>
                      </div>
                      <img src={data.replyMessage[0].thumbnail} className="w-[40px] h-[40px] rounded-[10px] mr-2" />
                    </div>
                  </div>
                </div>
              ) : data.replyMessage[0].type == "file" ? (
                <div className="rounded-[10px] flex w-full bg-[#EAFCE7] h-[58px] overflow-hidden my-4 border-opacity-25  mt-3 mb-3">
                  <div className="bg-[#06CF9C] w-[5px]"></div>
                  <div className="ml-2 flex flex-col justify-center w-full">
                    <h1 className="text-sm font-medium text-[#06CF9C]">
                      {String(data.replyMessage[0].author) == userId
                        ? data.authorName !== "ImWow Super Admin"
                          ? data.replyMessage[0].authorName
                          : "You"
                        : data.replyMessage[0].authorName}
                    </h1>
                    <div className="flex justify-between w-full items-center">
                      <div className="flex items-center gap-x-1">
                        <IoDocumentTextOutline />
                        <p>{data.replyMessage[0].content.split("/")[data.replyMessage[0].content.split("/").length - 1]}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : data.replyMessage[0].type === "audio" ? ( 
              <div className="rounded-[10px] flex w-[315px] bg-[#EAFCE7] h-[58px] overflow-hidden my-4 border-opacity-25  mt-3 mb-3">
                <div className="bg-[#06CF9C] w-[5px] pl-1"></div>
                                  <div className="flex ml-2 flex-row  w-full">
                                    <div className="flex flex-col w-full">
                                      <h1 className="text-sm font-medium text-[#06CF9C]">
                                        {String(data.replyMessage[0].author) == userId
                                          ? "You"
                                          : data.replyMessage[0].authorName}
                                      </h1>
                                      <div className="flex items-center gap-x-1">
                                        <FaMicrophone />
                                        <p>
                                          {" "}
                                          Voice Message {data.replyMessage[0].audioDuration}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
            ) : null}
            </div>
          ) : null}

          {data?.type === "audio" ? (
            <div className="px-2 pt-2 pb-1">
              <VoiceMessage audioSrc={data?.content} duration={data?.audioDuration} setActiveAudio={setActiveAudio} activeAudio={activeAudio} />
              <p className="font-extralight text-[11px] text-[#76767CCC] -mt-1.5 flex justify-end items-center gap-x-1 ">{data?.timeFormated}</p>
            </div>
          ) : null}
          {data.type == "text" ? (
            <div className="pl-3 pt-2 pb-1 pr-2">
              {!previewLoader ? (
                data.content?.indexOf("http") === 0 && Object.values(preview).length > 0 && preview[`key_${data._id}`] === String(data._id) ? (
                  <div className="w-[300px]">
                    <a href={preview.url} target="_blank" rel="noopener noreferrer">
                      {preview.image && <img src={preview.image} alt="preview" className="w-full h-48 object-cover mb-2 rounded-t-2xl" />}
                      <div className="font-bold max-h-14 overflow-hidden">{preview.title}</div>
                      <div className="text-sm text-gray-600 max-h-24 overflow-hidden">{preview.description}</div>
                    </a>
                  </div>
                ) : (
                  <Linkify
                    componentDecorator={(decoratedHref, decoratedText, key) => (
                      <a target="_blank" rel="noopener noreferrer" href={decoratedHref} key={key} className="link">
                        {decoratedText}
                      </a>
                    )}
                  >
                    <p className="leading-relaxed break-words whitespace-pre-wrap  ">{data?.content}</p>
                  </Linkify>
                )
              ) : (
                <LinkPreviewSkeleton />
              )}
              <p className="font-extralight text-[11px] text-[#76767CCC] -mt-1.5 flex justify-end items-center gap-x-1">{data?.timeFormated}</p>
            </div>
          ) : null}

          {(isHovered || isModalOpen) && (
            <div className="absolute top-0 right-0 z-1000 ">
              <div className="bg-white shadow-[#ED62141A] shadow-md rounded-[35px] py-2 px-3 flex items-center justify-between w-[70px] !float-right">
                <IoIosArrowDown size={20} color="#92929D" className="cursor-pointer" onClick={handleOpen} />
                <FaRegSmile size={20} color="#92929D" />
              </div>
              {openReply && (
                <ReplyInput isAtBottom={isAtBottom} deleteHandler={handleOpenModal} replyHandler={handleMessageReply} copyHandler={handleCopy} Css="!left-48 !mt-12 " />
              )}
            </div>
          )}
        </div>
      </div>
      {videoModal || imageModal ? (
        <Modal
          open={videoModal || imageModal}
          // onClose={() => console.log("on-close >>>")}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          BackdropProps={{
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          }}
        >
          <Box sx={style}>
            <div className=" relative flex items-center justify-center h-full w-full p-1">
              <RxCrossCircled
                size={35}
                className="absolute right-4 top-4 cursor-pointer"
                onClick={() => {
                  setVideoModal(false);
                  setImageModal(false);
                }}
              />

              {!imageModal ? (
                <video src={data?.content} controls autoPlay={true} muted={false} className="max-w-full max-h-full  rounded-[12px]" />
              ) : (
                <div className=" w-full flex justify-center items-center">
                  {isZoomed ? (
                    <Zoom>
                      <img src={data?.content} className="max-w-full max-h-full h-[120vh] object-contain rounded-[12px]" />
                    </Zoom>
                  ) : (
                    <img src={data?.content} className="w-auto h-[90vh] object-contain rounded-[12px]" onClick={() => setIsZoomed(true)} />
                  )}
                </div>
              )}
            </div>
          </Box>
        </Modal>
      ) : null}
    </>
  );
};

export default RecivedMessageTemplate;
